import APIClient from '@/shared/http/clients/api'

const resourceName = 'associados'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=nomeAssociado,asc`, data, config)
const GetAllInPa = (data = {}, filter, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?paId=${data}&nomeAssociado=${filter}&page=${index}&size=${limit}&sort=nomeAssociado,asc`, data, config)
const GetAllNotInCluster = (data = {}, filter, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?paId=${data}&nomeAssociado=${filter}&notInCluster=true&page=${index}&size=${limit}&sort=nomeAssociado,asc`, data, config)
const GetAllHasNotGerenteRelacionamento = (data = {}, filter, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?hasNotGR=true&paId=${data}&nomeAssociado=${filter}&page=${index}&size=${limit}&sort=nomeAssociado,asc`, data, config)
const updateAllGerenteRelacionamento = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/setallgr/`, data, config)
const updateAllCluster = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/setallcluster/`, data, config)
const updateMassGerenteRelacionamento = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/moveallgr/`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?size=${limit}&page=${index}`, config)
const GetAllWithoutManager = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/getwithoutmanager?size=${limit}&page=${index}&sort=pessoa.nome`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}`, data, config)
const Update = (id, data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Search = (filter = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?${filter}&page=${index}&size=${limit}`, config)
const GetByNumSisbr = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?numSisbr=${document}`, config)
const GetByDocument = (document, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}`, config)

// https://nxbr-demonstrativo-api.nexum.com.br/api/v1/associados/?document=91647711720

const AssociateRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  Create,
  Update,
  Delete,
  Search,
  GetByNumSisbr,
  GetByDocument,
  GetAllInPa,
  GetAllNotInCluster,
  GetAllHasNotGerenteRelacionamento,
  updateAllGerenteRelacionamento,
  updateAllCluster,
  updateMassGerenteRelacionamento,
  GetAllWithoutManager
}

export default AssociateRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/associate.js